var render = function render() {
  var _vm$$attrs$alt, _vm$$attrs$alt2
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _vm.name
    ? _c(
        "input",
        _vm._g(
          _vm._b(
            {
              attrs: {
                type: "image",
                name: _vm.name,
                src: _vm.url,
                width: _vm.size,
                height: _vm.size,
                role: _vm.ariaRole,
                alt:
                  (_vm$$attrs$alt = _vm.$attrs.alt) !== null &&
                  _vm$$attrs$alt !== void 0
                    ? _vm$$attrs$alt
                    : "",
              },
            },
            "input",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
    : _c(
        "img",
        _vm._g(
          _vm._b(
            {
              attrs: {
                src: _vm.url,
                width: _vm.size,
                height: _vm.size,
                role: _vm.ariaRole,
                alt:
                  (_vm$$attrs$alt2 = _vm.$attrs.alt) !== null &&
                  _vm$$attrs$alt2 !== void 0
                    ? _vm$$attrs$alt2
                    : "",
              },
            },
            "img",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }